/* eslint-disable import/prefer-default-export */

import { createAction } from 'redux-actions';

export const initOrgPicker = createAction('ORG_PICKER_INIT');
export const setSelectedOrg = createAction('ORG_PICKER_SELECT');
export const setIsLoadingOrgInfo = createAction('ORG_PICKER_IS_LOADING_INFO');
export const setOrgPickerNotice = createAction('ORG_PICKER_NOTICE_SET');
